import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import { AppDispatch, GlobalState } from "./store"

// Based on the quick start: https://redux-toolkit.js.org/tutorials/typescript
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<GlobalState> = useSelector
